import { action, noop, withAssign } from '@reatom/framework'

import { reatomDataTable } from '@root/shared/ui-kit'

import { createPositionsTableColumns } from '../../positions-table/ui/positions-table-columns'

import type { AggregatedPositionModel } from '@root/entities/position'

export const reatomWalletPositionsTableModel = ({
  position,
}: {
  position: AggregatedPositionModel
}) => {
  const tableModel = reatomDataTable({
    columns: createPositionsTableColumns({ withSellAll: false }),
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'positions-table',
    limit: 20,
    getId: (position) =>
      'id' in position ? position.id : position.pairAddress,
    initialItems: (ctx) => {
      const positions = ctx.get(position.walletPositions)
      return positions
    },
  })
  const initializeAction = action((_) => noop, 'initializeAction')

  return tableModel.pipe(
    withAssign(() => {
      return {
        initialize: initializeAction,
      }
    }),
  )
}
